export const CELCIUS = 'Celcius';
export const FAHRENHEIT = 'Fahrenheit';
export const HUMIDITY = 'Humidity';
export const PRESSURE = 'Pressure';
